import React, { Component } from 'react';
import { Header, Card, Image, Icon, Grid, Button, Modal } from 'semantic-ui-react'
import ReactPixel from 'react-facebook-pixel';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export default class LargeProjectOrderEntry_card extends Component {
    constructor(props) {
        super(props)
    }


    sendSelection = () => {
        console.log("obx61 +++++++++++; sendSelection");

        history.push("/dashboard/largeProjectEnterItem/" + this.props.projectId + "/" + this.props.item.itemType);
    }


    render() {
        return (
            <Card onClick={this.sendSelection}>
                {/* <Image src={this.props.image} width={600} height={600} size={this.props.imageSize} /> */}
                {/* <Image src={this.props.image} /> */}
                <Card.Content>
                    <Card.Header>
                        {this.props.item.itemTypeDescription}
                    </Card.Header>
                    {/* <Card.Meta>
                        <span className='date'>
                            {this.props.shortDescriptions}
                        </span>
                    </Card.Meta> */}
                    <Card.Description>
                        {this.props.item.itemTypeDescription}
                    </Card.Description>
                </Card.Content>

            </Card>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/LargeProjectOrderEntry_card.js